export default __webpack_public_path__ + "static/media/logo_black.8e82ddf4.svg";